// 8.3.8 Interview Practice UI (merged as `iv`).
const iv = {
 "scriptLatin": "Lateinisch",
 "scriptCyrillic": "Kyrillisch",
 "tabNew": "Neuer Chat",
 "tabChats": "Chats",
 "tabInterview": "Interview",
 "cardTitle": "Interviewtraining",
 "cardSub": "Übe ein wichtiges Gespräch, bevor es stattfindet.",
 "promise": "Übe die Gespräche, auf die es ankommt, bevor sie stattfinden.",
 "support": "Wähl ein Interview oder beschreib dein eigenes. Dein Gegenüber passt sich deinem Niveau und deinen Antworten an.",
 "fam": {
  "work": "Arbeit",
  "education": "Bildung",
  "travel": "Reisen & Behörden",
  "public": "Beruflich",
  "personal": "Privat",
  "custom": "Eigenes"
 },
 "sc": {
  "job": "Vorstellungsgespräch",
  "internship": "Praktikumsgespräch",
  "promotion": "Beförderungsgespräch",
  "freelance": "Vorstellung bei Kund:innen (freiberuflich)",
  "networking": "Networking",
  "university": "Studienplatz-Interview",
  "scholarship": "Stipendiengespräch",
  "oral_exam": "Mündliche Schulprüfung",
  "language_exam": "Mündliche Sprachprüfung",
  "visa": "Visum-ähnliches Interview",
  "travel_questions": "Fragen auf Reisen",
  "hotel_problem": "Problem im Hotel/auf Reisen",
  "media": "Medien-/Podcast-Interview",
  "presentation_qa": "Fragen nach einer Präsentation",
  "client_meeting": "Kundentermin",
  "pro_intro": "Berufliche Vorstellung",
  "housing": "Wohnungssuche",
  "doctor": "Arzttermin",
  "meet_new": "Jemanden kennenlernen",
  "difficult": "Schwieriges Gespräch",
  "custom": "Eigenes beschreiben"
 },
 "contextLabel": "Was sollte dein Gegenüber wissen?",
 "contextPh": "Optional: Stelle, Firma, Fach, was dich beunruhigt…",
 "customPh": "Beschreib dein Interview, z. B. „Morgen habe ich ein Vorstellungsgespräch als Hotelrezeptionist in Madrid.“",
 "length": "Länge",
 "quick": "Kurz — etwa 5 Fragen",
 "standard": "Standard — etwa 10 Fragen",
 "deep": "Ausführlich — etwa 15 Fragen",
 "style": "Übungsstil",
 "supportive": "Unterstützend",
 "realistic": "Realistisch",
 "challenging": "Fordernd",
 "start": "Interview starten",
 "starting": "Dein Gegenüber wird vorbereitet…",
 "progress": "{n} von {total}",
 "answerPh": "Deine Antwort…",
 "send": "Senden",
 "type": "Schreiben",
 "speak": "Sprechen",
 "listen": "Anhören",
 "help": "Hilf mir, es zu sagen",
 "helpPh": "Schreib, was du sagen willst, in einer beliebigen Sprache",
 "helpGo": "Zeigen",
 "helpNote": "Nutze es als Vorlage und schreib dann deine eigene Antwort.",
 "finished": "Danke, das Interview ist beendet. Schauen wir, wie es gelaufen ist.",
 "seeReport": "Mein Feedback ansehen",
 "building": "Dein Feedback wird erstellt…",
 "overall": "Gesamteindruck",
 "areasT": "Coaching-Bereiche",
 "areas": {
  "clarity": "Klarheit",
  "vocabulary": "Wortschatz",
  "grammar": "Grammatik",
  "naturalness": "Natürlichkeit",
  "effectiveness": "Wirkung im Interview"
 },
 "lv": {
  "strong": "Stark",
  "developing": "Im Aufbau",
  "needs_practice": "Übung nötig"
 },
 "worked": "Was gut lief",
 "improve": "Als Nächstes verbessern",
 "better": "Besser formuliert",
 "phrases": "Nützliche Wendungen",
 "save": "Speichern",
 "saved": "In Vocab gespeichert",
 "history": "Deine Interviews",
 "empty": "Noch keine Interviews.",
 "resume": "Fortsetzen",
 "startOver": "Neu beginnen",
 "view": "Ansehen",
 "st": {
  "active": "Läuft",
  "answered": "Bereit für Feedback",
  "completed": "Abgeschlossen"
 },
 "retry": "Etwas ist schiefgelaufen. Deine Antworten sind gespeichert – versuch es noch einmal.",
 "retryBtn": "Noch einmal",
 "newInterview": "Neues Interview",
 "back": "Zurück",
 "suggest": "Steht ein wichtiges Gespräch bevor?",
 "suggestBtn": "Interviewtraining ausprobieren",
 "dismiss": "Ausblenden",
 "recording": "Aufnahme… tippen zum Stoppen",
 "transcribing": "Wird transkribiert…",
 "micFail": "Die Stimme funktioniert nicht – schreib deine Antwort.",
 "disclaimer": "Nur Sprachtraining – keine Rechts-, Einwanderungs-, Medizin- oder Einstellungsberatung.",
 "describeFirst": "Beschreib zuerst dein Interview."
};
export default iv;
